import parseJwt from "./parseJwt";
import { default as JwtPayload } from "../models/JwtPayload";

export const getJwt = () => localStorage.getItem("jwt")!;
export const getJwtPayload = () => parseJwt<JwtPayload>(getJwt());
